import './bootstrap';
import './plugins';
import Vue from 'vue';
import Vuex from 'vuex';
import vuexI18n from 'vuex-i18n';
import './core/coreApp';
import './app/AppComponents';
import './app/DemoComponent';
import './app/Helpers/common/helpers';
import { ensureLanguagePersistence } from "./app/Helpers/LocalizationHelper";

window.Vue = Vue;


import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

/**
 * vuex
 */

Vue.use(Vuex);
import storeData from "./store/Index";
import { initializeBrandTheme } from "./core/helpers/app/BrandTheme";
import { initializeClientScope } from "./core/helpers/app/ClientScope";
import { initializeThemeMode } from "./core/helpers/app/ThemeMode";
const store = new Vuex.Store(storeData);

initializeThemeMode(store);
initializeBrandTheme(store);
initializeClientScope(store);


/**
 * localization
 * $t('key') or this.$('key')
 * link: https://github.com/dkfbasel/vuex-i18n
 * */

Vue.use(vuexI18n.plugin, store);

// add translations directly to the application
const { key, translations } = ensureLanguagePersistence();
Vue.i18n.add(key, translations);
// set the start locale to use
Vue.i18n.set(key);

/*------ localization end ------*/


const app = new Vue({
    store,
    el: '#app',
});
